import { useEffect, useState } from "react";
import { http, fmtErr } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function FoodTaxSettings() {
  const { user } = useAuth();
  const isOwner = user?.role === "SUPER_ADMIN";
  const [enabled, setEnabled] = useState(false);
  const [pct, setPct] = useState("0");
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    http.get("/admin/settings/food-tax").then((r) => {
      setEnabled(!!r.data.enabled);
      setPct(String(r.data.percentage ?? 0));
      setLoaded(true);
    }).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const r = await http.put("/admin/settings/food-tax", { enabled, percentage: parseFloat(pct) || 0 });
      setEnabled(r.data.enabled); setPct(String(r.data.percentage));
      toast.success("Food tax setting saved — applies to new food orders only");
    } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="card" data-testid="food-tax-settings">
      <h3 className="font-serif text-2xl mb-3">Food Tax / GST</h3>
      <p className="text-xs mb-4" style={{ color: "var(--muted)" }}>
        Applies only to <b>new</b> food orders. Historical orders and completed bills always keep their original recorded amounts.
      </p>
      <label className="flex items-center gap-3 mb-3 text-sm cursor-pointer">
        <input type="checkbox" style={{ width: "auto" }} data-testid="food-tax-enabled"
          checked={enabled} onChange={(e) => setEnabled(e.target.checked)} disabled={!isOwner} />
        Charge Food Tax / GST on new food orders
      </label>
      {enabled && (
        <div className="mb-3">
          <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Tax percentage</label>
          <div className="flex items-center gap-2">
            <input type="number" min="0" max="50" step="0.1" data-testid="food-tax-percentage"
              value={pct} onChange={(e) => setPct(e.target.value)} disabled={!isOwner} style={{ width: 110 }} />
            <span className="text-sm">%</span>
          </div>
        </div>
      )}
      {!enabled && <p className="text-xs mb-3" style={{ color: "var(--pine)" }} data-testid="food-tax-off-note">Food tax is OFF — new food orders are charged at menu price with no tax added.</p>}
      {isOwner ? (
        <button data-testid="food-tax-save" onClick={save} disabled={!loaded || busy} className="btn-primary">{busy ? "Saving…" : "Save"}</button>
      ) : (
        <p className="text-xs" style={{ color: "var(--muted)" }} data-testid="food-tax-readonly">Only the Owner can change this setting.</p>
      )}
    </div>
  );
}
